// extracted by mini-css-extract-plugin
export default {"resume":"Resume_resume__KZJCM","experience":"Resume_experience__UQD-v","education":"Resume_education__3CR-K","educationDetails":"Resume_educationDetails__xg1bH"};